var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"popular_bundles"}},[_c('slider-section',{key:_vm.key,attrs:{"id":"normal-cards","method":"getPage","obj":_vm.bundleRepo,"routing":"popular-bundles","sliderHolder":"popularBundles","data":_vm.info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }